import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function ConnectCalendar() {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");
  const email = params.get("email");
  const reason = params.get("reason");

  const [loading, setLoading] = useState(false);
  const [conn, setConn] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/oauth/google/status`);
        setConn(data);
      } catch (_) {
        setConn({ connected: false });
      }
    })();
  }, []);

  const connect = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${API}/oauth/google/login`);
      window.location.href = data.authorization_url;
    } catch (e) {
      setLoading(false);
      alert("Kunde inte starta inloggning. Försök igen.");
    }
  };

  return (
    <main className="min-h-screen bg-cream text-ink py-24 px-6">
      <div className="max-w-xl mx-auto">
        <p className="eyebrow text-ink2">— Admin · Kalenderkoppling</p>
        <h1 className="headline text-4xl md:text-5xl mt-4 mb-6">
          Anslut Daniels Google Calendar.
        </h1>
        <p className="text-base text-ink2 leading-relaxed mb-10">
          Logga in en gång med <strong>kontakt@bmjuridik.se</strong>. Webbplatsen
          läser då lediga tider direkt från kalendern och skapar nya events
          automatiskt vid bokning.
        </p>

        {status === "connected" && (
          <div
            className="border border-line bg-stone50 p-6 mb-8"
            data-testid="connect-success"
          >
            <p className="font-serif text-2xl text-ink mb-2">Ansluten ✓</p>
            <p className="text-sm text-ink2">
              Konto: <strong>{email}</strong>. Bokningsfunktionen är nu live.
            </p>
          </div>
        )}
        {status === "error" && (
          <div
            className="border border-line bg-stone50 p-6 mb-8"
            data-testid="connect-error"
          >
            <p className="font-serif text-2xl text-ink mb-2">Något gick fel</p>
            <p className="text-sm text-ink2">Orsak: {reason || "okänd"}</p>
          </div>
        )}

        {conn && (
          <div className="border-t border-line pt-8 mb-10">
            <p className="text-sm text-ink2">
              Status:{" "}
              <span
                className={
                  conn.connected ? "text-ink font-medium" : "text-ink2 italic"
                }
                data-testid="conn-status"
              >
                {conn.connected ? "Ansluten" : "Inte ansluten"}
              </span>
            </p>
            <p className="text-sm text-ink2 mt-1">
              Förväntat konto: <strong>{conn.email}</strong>
            </p>
          </div>
        )}

        <button
          onClick={connect}
          disabled={loading}
          data-testid="connect-google-btn"
          className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-ink text-cream text-sm font-medium hover:bg-ink2 transition-all duration-300 disabled:opacity-50"
        >
          {loading ? "Öppnar Google…" : conn?.connected ? "Återanslut Google Calendar" : "Anslut Google Calendar"}
          <span>→</span>
        </button>

        <p className="mt-12 text-xs text-ink2 leading-relaxed border-t border-line pt-6">
          Den här sidan är endast för administration. Webbplatsen begär enbart
          access till kalenderhändelser för att läsa lediga tider och skapa
          bokningar — ingen annan data läses.
        </p>
      </div>
    </main>
  );
}
